import React, { useEffect, useState } from 'react';
import parse from 'html-react-parser';

import { IProduct, INutrient } from '@interfaces';
import Clickable from '@v2/components/common/presentational/clickables/default';
import styles from '@components/common/products/product.styles';
import { ContentLoader } from '../../presentational/loader/loader';
import NutrientService from '@v2/services/nutrient.service';
import { apiImageSource } from '@v2/utils/http';
import { WPImage } from '@v2/utils/image';

export default function ProductDevelopmental({ product }: { product?: IProduct }) {
    const [active, setActive] = useState(0);
    const [nutrient, setNutrient] = useState(null);
    const [loading, setLoading] = useState(true);

    const getNutrient = () => {
        if (product.nutrients[active].minified) {
            setLoading(true);

            NutrientService
                .get(product.nutrients[active].id)
                .then(setNutrient)
                .finally(() => setLoading(false));
        } else {
            setNutrient(product.nutrients[active]);
            setLoading(false);
        }
    }

    useEffect(() => {
        getNutrient();
    }, [active]);

    useEffect(() => {
        setActive(0);
        getNutrient();
    }, [product]);

    return (
        <div className={styles.developmental}>
            <h3>your child’s growing brain</h3>
            <h2>so much is happening in the first few months</h2>
            <p>
                What you feed your child now plays a critical role in their brain development.
                During the first few years of life, the brain is making millions of new connections
                every day and different regions are growing at different times.
            </p>
            <div className="developmental-tabs">
                <div className="tabs">
                    {product.nutrients &&
                        product.nutrients
                            .filter((nutrient: INutrient) => nutrient.starAttribute)
                            .map((nutrient: INutrient, key: number) =>
                                key < 4 &&
                                    <Clickable
                                        key={key}
                                        onClick={() => setActive(key)}
                                        className={`tab ${key === active ? 'active' : ''}`}>
                                        <img src={apiImageSource(`nutrient?id=${nutrient.id}`)} alt={''} />
                                        <span>{nutrient.title}</span>
                                    </Clickable>
                            )}
                </div>
                <div className="tab-content">
                    <div className="header">
                        <div className="headings">
                            <h5>brain section</h5>
                            <h4>{nutrient && nutrient.developmental && nutrient.developmental.brainText}</h4>
                        </div>
                        {/*
                        <div className="stage">
                            <span className="period">{nutrient.developmental.age}</span>
                            <span className="months">months</span>
                        </div>
                        */}
                    </div>
                    <div>
                        <ContentLoader loading={loading}>
                            {(nutrient && nutrient.developmental && nutrient.developmental.brainDescription)
                                ? parse(nutrient.developmental.brainDescription)
                                : ''}
                        </ContentLoader>
                    </div>
                    {/* Pending audio asset */}
                    {/*
                        <div className="video-controls">
                            <div className="control">
                                <img src={img('pdp2/product-description/play.svg')} alt="" />
                            </div>
                            <div className="heading">
                                <span>our founder</span>
                            </div>
                        </div>
                        */}
                </div>
                {(nutrient && nutrient.developmental && !loading) &&
                    <WPImage className="brain" src={nutrient.developmental.brainImage} alt="" />}
            </div>
        </div>
    );
}